/* eslint-disable */

import FlexCol from "../flex-col/flex-col.tsx";
import RaindropBackButtonPanel from "../raindrop-back-button-panel/raindrop-back-button-panel.tsx";
import RaindropTopBar from "../raindrop-top-bar/raindrop-top-bar.tsx";

const RaindropPage = ({
  children,
  hasBackNavigation = false,
  isFullX = false,
  className = "",
  showTopBar = false,
}) => {
  let tailwindPadding = "py-6 px-6";

  if (isFullX) {
    tailwindPadding = "py-6 px-0";
  }

  return (
    <FlexCol
      className={`overflow-y-auto h-full no-scrollbar ${tailwindPadding} ${className}`}
    >
      {showTopBar && <RaindropTopBar isFluid={true} />}
      {hasBackNavigation && <RaindropBackButtonPanel />}
      {children}
    </FlexCol>
  );
};

export default RaindropPage;
